/**
 * Frontend Sentry SDK initialization.
 *
 * Reads config from <meta> tags injected by Rails (sentry_meta_tags helper).
 * Only initializes when a DSN is present (i.e. production).
 * Must be imported BEFORE Turbo/Stimulus so boot-time errors are captured.
 */
import * as Sentry from "@sentry/browser";

const dsn = document
  .querySelector('meta[name="sentry-dsn"]')
  ?.getAttribute("content");

if (dsn) {
  const release =
    document
      .querySelector('meta[name="sentry-release"]')
      ?.getAttribute("content") || undefined;

  const environment =
    document
      .querySelector('meta[name="sentry-environment"]')
      ?.getAttribute("content") || "production";

  Sentry.init({
    dsn,
    release,
    environment,

    // Keep the default rate low — most value comes from error tracking
    tracesSampleRate: 0,

    ignoreErrors: [
      // Browser extensions & third-party noise
      /ResizeObserver loop/,
      /ResizeObserver loop completed with undelivered notifications/,
      // Chunk loading failures (deploy + cached HTML)
      /Loading chunk [\d]+ failed/,
      /Failed to fetch dynamically imported module/,
      /Importing a module script failed/,
      // Network errors
      /Network request failed/,
      /NetworkError/,
      /Failed to fetch/,
      /Load failed/,
      // Safari-specific
      /cancelled/,
      // Browser built-in (not actionable)
      /AbortError/,
      /NotAllowedError/,
    ],

    denyUrls: [
      // Chrome extensions
      /extensions\//i,
      /^chrome:\/\//i,
      /^chrome-extension:\/\//i,
      // Firefox extensions
      /^moz-extension:\/\//i,
      // Safari extensions
      /^safari-extension:\/\//i,
    ],
  });
}
